import { ActivityCard } from "@/components";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui";
import useCostAnalytics from "./useCostAnalytics";
import { COST } from "../consts";
import { CostAnalyticsProps } from "./types";
import { CopyDistributionConfig } from "./CopyDistributionConfig";

const CostAnalytics = ({
  onCreateCardClick,
  onCardClick,
}: CostAnalyticsProps) => {
  const { costAnalyticsCards, openCopyDistributionConfig, setOpenCopyDistributionConfig } = useCostAnalytics();
  return (
    <>
      <AccordionItem
        value={COST}
        className="bg-white px-5 mb-[20px] rounded-lg shadow-md"
      >
        <AccordionTrigger className="cursor-pointer">
          Cost Analytics
        </AccordionTrigger>
        <AccordionContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px] py-4">
            {costAnalyticsCards?.map((data: any, index: number) => {
              return (
                <ActivityCard
                  key={`cost-analytics-${index}`}
                  isCreate={data.id == "create"}
                  isSummary={data.id == "summary"}
                  isValueObject={data.id == "valueObject"}
                  isTitleOnly={data.id == "titleOnly"}
                  hideCount={(data as any).hideCount || false}
                  data={data}
                  onCardClick={
                    data.id == "create" && data?.link
                      ? onCreateCardClick(data?.link)
                      : data.onClick ? data.onClick : onCardClick(data?.link)
                  }
                />
              );
            })}
          </div>
        </AccordionContent>
      </AccordionItem>
      {openCopyDistributionConfig && <CopyDistributionConfig 
        open={openCopyDistributionConfig}
        setOpen={setOpenCopyDistributionConfig}
      />}
    </>
  );
};

export default CostAnalytics;
